import { render, staticRenderFns } from "./addtimes.vue?vue&type=template&id=2ace9241"
import script from "./addtimes.vue?vue&type=script&lang=js"
export * from "./addtimes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports